import React from 'react';

import { RevampedCheckoutFlowMobile } from '@editor/components/UpgradeFlowModal/RevampedCheckoutFlowMobile';
import { useRevampedCheckoutFlowVariant } from '@editor/global/growthbookUtils';
import { isMobileOperatingSystem as getIsMobileOperatingSystem } from '@repo/detection';
import { withEventScope } from '@repo/event-processor';

import ModalWrapper from '../ModalWrapper';
import { SubscriptionModalProps } from '../types';

import { SubscriptionModalContent } from './SubscriptionModalContent';

/**
 * This component mounts the subscription modal.
 */
const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
  isOpen,
  onClose,
  ...contentProps
}) => {
  // Revamped checkout flow
  const showRevampedCheckoutFlow = useRevampedCheckoutFlowVariant() !== 'off';
  const shouldShowRevampedMobileCheckoutFlow =
    showRevampedCheckoutFlow && getIsMobileOperatingSystem();

  const SubscriptionModalContentContainer = shouldShowRevampedMobileCheckoutFlow
    ? RevampedCheckoutFlowMobile
    : ModalWrapper;

  return (
    <SubscriptionModalContentContainer isOpen={isOpen} onClose={onClose}>
      <SubscriptionModalContent onClose={onClose} {...contentProps} />
    </SubscriptionModalContentContainer>
  );
};

/** @knipignore - used in website */
export default withEventScope(SubscriptionModal, {
  feature: 'subscriptionModal',
});
